export default "__VITE_ASSET__DgA8GY9S__"